module.exports = __webpack_public_path__ + "static/media/gift05_ja.0255cc3d.png";